import { BehaviorType } from "../types";
import Behavior from "../types/Behavior";
import { BEHAVIOR_AFTER_EVENT_DELAY, BEHAVIOR_NEXT_EVENT_DELAY } from "../utils/variables";
class ResizeBehavior extends Behavior {
    constructor(plasm, appName, addMetadata) {
        super(plasm, appName, addMetadata);
        this.id = BehaviorType.resize;
        this.handler = (event) => this.onResize(event);
    }
    onResize(event) {
        if (this.isOnHandler) {
            return;
        }
        this.isOnHandler = true;
        this.addLog(event, this.id);
        setTimeout(() => {
            this.addLog(event, BehaviorType.afterresize, {
                windowSize: {
                    width: window.innerWidth,
                    height: window.innerHeight,
                },
            });
        }, BEHAVIOR_AFTER_EVENT_DELAY);
        setTimeout(() => {
            this.isOnHandler = false;
        }, BEHAVIOR_NEXT_EVENT_DELAY);
    }
}
export default ResizeBehavior;
